(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    // Drives the existing minInput/maxInput text fields rather than
  // replacing them — dragging updates those inputs' .value and dispatches
  // a real "change" event on price-facet-component, which already listens
  // for that (on:change="/updatePriceFilterAndResults") and applies the
  // filter exactly as it did for typed input. This is additive only; the
  // actual filtering logic in facets.js is untouched.
  (function () {
    function initPriceSlider(slider) {
      if (slider.dataset.priceSliderInit) return;
      slider.dataset.priceSliderInit = 'true';

      var component = slider.closest('price-facet-component');
      if (!component) return;

      var fill = slider.querySelector('.price-facet__slider-fill');
      var thumbMin = slider.querySelector('[ref="sliderThumbMin"]');
      var thumbMax = slider.querySelector('[ref="sliderThumbMax"]');
      var textMin = component.querySelector('[ref="minInput"]');
      var textMax = component.querySelector('[ref="maxInput"]');
      if (!fill || !thumbMin || !thumbMax || !textMin || !textMax) return;

      var rangeMax = parseFloat(slider.dataset.rangeMax) || 0;
      var minVal = parseFloat(thumbMin.getAttribute('aria-valuenow')) || 0;
      var maxVal = parseFloat(thumbMax.getAttribute('aria-valuenow'));
      if (isNaN(maxVal)) maxVal = rangeMax;

      function clamp(val, lo, hi) {
        return Math.max(lo, Math.min(hi, val));
      }

      function render() {
        var minPct = rangeMax ? clamp((minVal / rangeMax) * 100, 0, 100) : 0;
        var maxPct = rangeMax ? clamp((maxVal / rangeMax) * 100, 0, 100) : 100;
        fill.style.left = minPct + '%';
        fill.style.right = (100 - maxPct) + '%';
        thumbMin.style.left = minPct + '%';
        thumbMax.style.left = maxPct + '%';
        thumbMin.setAttribute('aria-valuenow', Math.round(minVal));
        thumbMax.setAttribute('aria-valuenow', Math.round(maxVal));
      }

      function updateTextInputs() {
        // Whole dollars, no cents — matches the no-decimal display
        // convention now used everywhere else in this box (Liquid-side
        // values/placeholder use `| split: '.' | first` for the same
        // reason). Stock's PriceFacetComponent only reformats these
        // boxes when a value is clamped out of bounds, so a drag commit
        // needs to already be in the right format itself.
        textMin.value = Math.round(minVal);
        textMax.value = Math.round(maxVal);
      }

      function commitChange() {
        component.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function valueFromClientX(clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = rect.width ? (clientX - rect.left) / rect.width : 0;
        return clamp(pct, 0, 1) * rangeMax;
      }

      function startDrag(thumb, isMin) {
        return function (e) {
          e.preventDefault();
          if (thumb.setPointerCapture) {
            try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
          }

          function move(ev) {
            var val = valueFromClientX(ev.clientX);
            if (isMin) {
              minVal = clamp(val, 0, maxVal);
            } else {
              maxVal = clamp(val, minVal, rangeMax);
            }
            render();
            updateTextInputs();
          }

          function up() {
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            commitChange();
          }

          document.addEventListener('pointermove', move);
          document.addEventListener('pointerup', up);
        };
      }

      thumbMin.addEventListener('pointerdown', startDrag(thumbMin, true));
      thumbMax.addEventListener('pointerdown', startDrag(thumbMax, false));

      function handleKey(isMin) {
        return function (e) {
          var delta = 0;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') delta = -1;
          else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') delta = 1;
          else return;
          e.preventDefault();
          if (isMin) {
            minVal = clamp(minVal + delta, 0, maxVal);
          } else {
            maxVal = clamp(maxVal + delta, minVal, rangeMax);
          }
          render();
          updateTextInputs();
          commitChange();
        };
      }

      thumbMin.addEventListener('keydown', handleKey(true));
      thumbMax.addEventListener('keydown', handleKey(false));

      function syncFromText() {
        var newMin = parseFloat(textMin.value) || 0;
        var newMax = parseFloat(textMax.value);
        if (isNaN(newMax)) newMax = rangeMax;
        minVal = clamp(newMin, 0, rangeMax);
        maxVal = clamp(newMax, minVal, rangeMax);
        render();
      }

      textMin.addEventListener('change', syncFromText);
      textMax.addEventListener('change', syncFromText);

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-price-slider]').forEach(initPriceSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Filter results re-render the facets markup via section morphing —
    // catch newly-added slider instances afterward.
    var priceSliderObserver = new MutationObserver(function () {
      document.querySelectorAll('[data-price-slider]:not([data-price-slider-init])').forEach(initPriceSlider);
    });
    priceSliderObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.closest('#search-modal')) return;
    const resetBtn = input.closest('predictive-search-component')?.querySelector('.predictive-search__reset-button');
    if (resetBtn) resetBtn.hidden = input.value.trim().length === 0;
  });
  } catch(e) { console.error(e); }
})();

})();
